import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useParams } from "react-router-dom";

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { topic } = useParams();
  const formattedTopic = topic
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

  const faqs = [
    {
      question: `What makes Exact Mails a top alternative to ${formattedTopic} for email discovery?`,
      answer: `Exact Mails is a standout alternative to ${formattedTopic}, providing more verified emails, faster bulk processing, and a pay-only-for-verified-emails pricing model.`,
    },
    {
      question: `Why should I choose Exact Mails over ${formattedTopic}?`,
      answer: `Exact Mails specializes in email discovery, offering greater accuracy, more verified results, and a cost-effective pricing structure. Unlike ${formattedTopic}, it charges only for fully verified emails and includes catch-all and unknown results at no extra cost.`,
    },
    {
      question: `Does Exact Mails outperform ${formattedTopic} in finding emails?`,
      answer: `Yes, Exact Mails consistently discovers more emails than ${formattedTopic}. In tests, it found +38% more emails overall and +33% more verified emails, ensuring better results for your campaigns.`,
    },
    {
      question: `How accurate is Exact Mails compared to ${formattedTopic}?`,
      answer: `Exact Mails ensures over 97% deliverability for fully verified emails through advanced verification techniques, making it a more reliable choice for accurate email discovery than ${formattedTopic}.`,
    },
    {
      question: `How does Exact Mails compare to ${formattedTopic} in terms of bulk email searches?`,
      answer: `Exact Mails processes bulk email searches up to 8x faster than ${formattedTopic}, supports larger file sizes (up to 100k rows vs. 25k rows), and accommodates various file formats like CSV and Excel.`,
    },
    {
      question: `How does Exact Mails' pricing stack up against ${formattedTopic}?`,
      answer: `Exact Mails offers more value by charging only for verified emails. For example, with the $49 plan, you get 1,000 fully verified emails, while ${formattedTopic} offers only 500 mixed-quality emails.`,
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-2xl mx-auto mt-14 mb-24">
      <h2 className="text-2xl lg:text-3xl text-gray-700 font-semibold text-center mb-6 lg:mb-10">
        Frequently asked questions
      </h2>
      {faqs.map((faq, index) => (
        <div key={index} className="border-b border-gray-200">
          <button
            onClick={() => toggleFAQ(index)}
            className="w-full flex justify-between items-center py-4 text-left text-lg font-medium text-gray-800"
          >
            {faq.question}
            {openIndex === index ? (
              <FaChevronUp className="text-gray-600" />
            ) : (
              <FaChevronDown className="text-gray-600" />
            )}
          </button>
          {openIndex === index && (
            <div className="px-4 py-4 text-gray-600 bg-[#F0F0F0] border-t border-gray-200 text-sm">
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FaqSection;
